import React, { useMemo } from 'react';

import { createStyles, Theme, WithStyles, withStyles } from '@material-ui/core';
import MuiToolbar, { ToolbarProps as MuiToolbarProps } from '@material-ui/core/Toolbar';
import classnames from 'classnames';

const styles = ({
  palette: {
    common: { white },
  },
  custom: {
    palette: { colorSupportSlate },
  },
}: Theme) =>
  createStyles({
    root: {},
    /* Styles applied to the root element if `color="supportSlate"`. */
    colorSupportSlate: {
      color: white,
      backgroundColor: colorSupportSlate,
      '& svg': {
        color: white,
      },
    },
  });

export interface ToolbarProps extends Omit<MuiToolbarProps, 'classes' | 'color'>, WithStyles<typeof styles> {
  color?: MuiToolbarProps['color'] | 'supportSlate';
}

const ToolbarComponent: React.FC<ToolbarProps> = ({ classes: classesProp, className, color: colorProp, ...rest }) => {
  const classes = useMemo(() => {
    const res: MuiToolbarProps['classes'] = {
      root: classnames(
        {
          [classesProp.colorSupportSlate]: colorProp === 'supportSlate',
        },
        className,
      ),
    };
    return res;
  }, [className, classesProp, colorProp]);

  return <MuiToolbar classes={classes} {...rest} />;
};

export const Toolbar = withStyles(styles, { name: 'LumaToolbar' })(ToolbarComponent);
